module.exports = __webpack_public_path__ + "img/UPICARDPOS.c46c3bae.png";